import { render, staticRenderFns } from "./AdminPrinterClients.vue?vue&type=template&id=359c9352&scoped=true&"
import script from "./AdminPrinterClients.vue?vue&type=script&lang=ts&"
export * from "./AdminPrinterClients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c9352",
  null
  
)

export default component.exports